import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from 'utils/base-query'
import { BaseCandleDto, BaseCandleFilter, buildQueryString } from '../candles.types'

export { CHSort, CandleInterval } from '../candles.types'

export type PolymarketCandle = BaseCandleDto & {
  outcome: PolymarketTradeOutcome
}

export enum PolymarketTradeSide {
  BUY = 'BUY',
  SELL = 'SELL'
}

export enum PolymarketTradeOutcome {
  UP = 'UP',
  DOWN = 'DOWN'
}

export interface PolymarketCandleFilter extends BaseCandleFilter {
  series: string
  outcome: PolymarketTradeOutcome
}

export type PolymarketLastTrades = {
  outcome: PolymarketTradeOutcome
  series: string
  price: number
}

export const apiPolymarket = createApi({
  reducerPath: 'apiPolymarket',
  baseQuery: baseQuery,
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getLastTrades: builder.query<PolymarketLastTrades[], undefined>({
      query: () => '/polymarket/last-trades'
    }),
    // Было два эндпоинта getCandlesUp/getCandlesDown с идентичным телом,
    // отличавшихся одним параметром outcome.
    getCandles: builder.query<PolymarketCandle[], PolymarketCandleFilter>({
      query: ({outcome, series, startTime, endTime, intervalMs, limit, offset, sort}) =>
        `polymarket/candles?${ buildQueryString({
          outcome,
          series,
          startTime,
          endTime,
          intervalMs,
          limit,
          offset,
          sort
        }) }`
    })
  })
})

export const {
  useGetLastTradesQuery,
  useGetCandlesQuery
} = apiPolymarket
